import { render, staticRenderFns } from "./testquestionuser.vue?vue&type=template&id=d879d608&scoped=true"
import script from "./testquestionuser.vue?vue&type=script&lang=ts"
export * from "./testquestionuser.vue?vue&type=script&lang=ts"
import style0 from "./testquestionuser.vue?vue&type=style&index=0&id=d879d608&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d879d608",
  null
  
)

export default component.exports